import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { shortListPath, shortListEditPath, homePath } from 'routes'

const GET_SHORT_LIST = makeKeys('GET_SHORT_LIST')
const GET_VENDOR_DETAIL = makeKeys('GET_VENDOR_DETAIL')
const CREATE_SHORT_LIST = makeKeys('CREATE_SHORT_LIST')
const UPLOAD_SL_ATTACHMENTS = makeKeys('UPLOAD_SL_ATTACHMENTS')
const SUBMIT_SHORT_LIST = makeKeys('SUBMIT_SHORT_LIST')
const GET_SHORT_LIST_DETAIL = makeKeys('GET_SHORT_LIST_DETAIL')
const UPDATE_SHORT_LIST = makeKeys('UPDATE_SHORT_LIST')
const GET_PRE_Q_FORMULAS = makeKeys('GET_PRE_Q_FORMULAS')
const DELETE_SHORT_LIST = makeKeys('DELETE_SHORT_LIST')
const GET_SL_WORKFLOW = makeKeys('GET_SL_WORKFLOW')
const ACTION_SHORT_LIST = makeKeys('ACTION_SHORT_LIST')
const CLEAR_SL_FROM_DATA = 'CLEAR_SL_FROM_DATA'

export const getShortLists = makeAction(GET_SHORT_LIST.REQUEST, 'query')
export const getVendorDetail = makeAction(GET_VENDOR_DETAIL.REQUEST, 'vendorCode', 'onSuccess')
export const createShortList = makeAction(CREATE_SHORT_LIST.REQUEST, 'data', 'isSubmit', 'history')
export const uploadAttachments = makeAction(UPLOAD_SL_ATTACHMENTS.REQUEST, 'id', 'data', 'isSubmit','history', 'actionKey')
export const submitShortList = makeAction(SUBMIT_SHORT_LIST.REQUEST, 'id', 'history')
export const getShortListDetail = makeAction(GET_SHORT_LIST_DETAIL.REQUEST, 'id')
export const updateShortList = makeAction(UPDATE_SHORT_LIST.REQUEST, 'data', 'isSubmit', 'history', 'actionKey')
export const getPreQFormulas = makeAction(GET_PRE_Q_FORMULAS.REQUEST)
export const deleteShortList = makeAction(DELETE_SHORT_LIST.REQUEST, 'id', 'history')
export const clearFormData = makeAction(CLEAR_SL_FROM_DATA)
export const getWorkflow = makeAction(GET_SL_WORKFLOW.REQUEST, 'id')
export const actionShortList = makeAction(ACTION_SHORT_LIST.REQUEST, 'data', 'history')

const getShortListsSuccess = makeAction(GET_SHORT_LIST.SUCCESS, 'data')
const getShortListsFailure = makeAction(GET_SHORT_LIST.FAILURE)
const getShortListDetailSuccess = makeAction(GET_SHORT_LIST_DETAIL.SUCCESS, 'data')
const getPreQFormulasSuccess = makeAction(GET_PRE_Q_FORMULAS.SUCCESS, 'data')
const getWorkflowSuccess = makeAction(GET_SL_WORKFLOW.SUCCESS, 'data')

const apiPath = path => path ? urlWithPrefix(`shortLists/${path}`) : urlWithPrefix('shortLists')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getShortListsRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Short List Data'))
    const response = yield httpGet(apiPath(), query)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getShortListsSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Short List Error!'))
    }
    yield put(getShortListsFailure())
    yield put(appLoaded())
  }
}

function* getVendorDetailRequest(action) {
  const { vendorCode, onSuccess } = action.payload

  try {
    yield put(appLoading('Loading vendor data'))
    const response = yield httpGet(apiPath(`vendor/${vendorCode}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess(response.data)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load vendor error!'))
    }
    yield put(appLoaded())
  }
}

function* createShortListRequest(action) {
  const { data, isSubmit, history } = action.payload

  try {
    yield put(appLoading('Creating short list data.'))
    const response = yield httpPost(apiPath(), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      const { id } = response.data
      var attachmentsData = {}
      if (data.SL01) attachmentsData.SL01 = data.SL01

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(id, attachmentsData, isSubmit, history))
      } else {
        if (isSubmit) {
          yield put(submitShortList(id, history))
        } else {
          yield put(toastSuccess('Create short list success.'))
          history.push(shortListPath)
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create short list error!'))
    }
  }
}

function* uploadAttachmentsRequest(action) {
  const { id, data, isSubmit, history, actionKey } = action.payload

  // const config = {
  //   onUploadProgress: (progressEvent) => {
  //     var percentCompleted = ((progressEvent.loaded * 100) / progressEvent.total).toFixed(2).replace('.00', '')
  //     var uploaded = (progressEvent.loaded / 1024).toFixed(2).replace('.00', '')
  //     var total = (progressEvent.total / 1024).toFixed(2).replace('.00', '')
  //     var uploadProgress = `${percentCompleted}% (${uploaded} KB / ${total} KB)`
  //     showAppLoading(`Upload attachments. ${uploadProgress}`)
  //   }
  // }

  try {
    yield put(appLoading(`Upload attachments.`))
    const response = yield httpPost(apiPath(`${id}/attachments`), data, multipartHeader /*, config */)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (isSubmit) {
          yield put(submitShortList(id, history))
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionShortList(submitData, history))
          } else {
            yield put(toastSuccess('Save short list success.'))
            yield put(appLoaded())
            history.push(shortListPath)
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Upload attachments data fail.'))
  }
}

function* getShortListDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading short list data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getShortListDetailSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load short list data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateShortListRequest(action) {
  const { data, isSubmit, history, actionKey = '' } = action.payload

  try {
    yield put(appLoading('Updating short list data.'))
    const response = yield httpPut(apiPath(data.id), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      var attachmentsData = {}
      if (data.SL01) attachmentsData.SL01 = data.SL01

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(data.id, attachmentsData, isSubmit, history, actionKey))
      } else {
        if (isSubmit) {
          yield put(submitShortList(data.id, history))
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionShortList(submitData, history))
          } else {
            yield put(toastSuccess('Update short list success.'))
            history.push(shortListPath)
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update short list error!'))
    }
  }
}

function* getPreQFormulasRequest(action) {
  try {
    const response = yield httpGet(apiPath('preq/formulas'))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPreQFormulasSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPreQFormulasSuccess([]))
  }
}

function* submitShortListRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Submit short list data.'))
    const response = yield httpPost(apiPath(`${id}/submit`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        history.push(shortListPath)
        yield put(toastSuccess('Submit short list data success.'))
      } else {
        yield put(toastError('Submit short list data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    history.push(shortListEditPath(id))
    yield put(toastError(e.data.message))
  }
}

function* deleteShortListRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Delete short list data.'))
    const response = yield httpDelete(apiPath(`${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Delete short list data success.'))
        history.push(shortListPath)
      } else {
        yield put(toastError('Delete short list data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* getWorkflowRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(apiPath('workflowApproverViewMode'), { id })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorkflowSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getWorkflowSuccess([]))
  }
}

function* actionShortListRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(apiPath(`${data.id}/action`), data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(shortListPath)
      }
      yield put(toastSuccess('Action short list success.'))
    }
  } catch (e) {
    yield put(toastError(e.data.message || 'Action short list fail.'))
    yield put(appLoaded())
  }
}

export function* watchShortListSaga() {
  yield takeLatest(GET_SHORT_LIST.REQUEST, getShortListsRequest)
  yield takeLatest(GET_VENDOR_DETAIL.REQUEST, getVendorDetailRequest)
  yield takeLatest(CREATE_SHORT_LIST.REQUEST, createShortListRequest)
  yield takeLatest(UPLOAD_SL_ATTACHMENTS.REQUEST, uploadAttachmentsRequest)
  yield takeLatest(GET_SHORT_LIST_DETAIL.REQUEST, getShortListDetailRequest)
  yield takeLatest(UPDATE_SHORT_LIST.REQUEST, updateShortListRequest)
  yield takeLatest(GET_PRE_Q_FORMULAS.REQUEST, getPreQFormulasRequest)
  yield takeLatest(SUBMIT_SHORT_LIST.REQUEST, submitShortListRequest)
  yield takeLatest(DELETE_SHORT_LIST.REQUEST, deleteShortListRequest)
  yield takeLatest(GET_SL_WORKFLOW.REQUEST, getWorkflowRequest)
  yield takeLatest(ACTION_SHORT_LIST.REQUEST, actionShortListRequest)
}

const initial = {
  listShortLists: { data: [], loading: false },
  shortList: { data: {}, loading: false },
  preQFormulas: { data: [], loading: false },
  workflow: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_SHORT_LIST.REQUEST]: () => ({
    ...state,
    listShortLists: { data: [], loading: true }
  }),
  [GET_SHORT_LIST.SUCCESS]: (data) => ({
    ...state,
    listShortLists: { data: data.data, loading: false }
  }),
  [GET_SHORT_LIST.FAILURE]: (data) => ({
    ...state,
    listShortLists: { data: [], loading: false }
  }),
  [GET_SHORT_LIST_DETAIL.REQUEST]: () => ({
    ...state,
    shortList: { data: {}, loading: true }
  }),
  [GET_SHORT_LIST_DETAIL.SUCCESS]: (data) => ({
    ...state,
    shortList: { data: data.data, loading: false }
  }),
  [GET_PRE_Q_FORMULAS.REQUEST]: () => ({
    ...state,
    preQFormulas: { data: [], loading: true }
  }),
  [GET_PRE_Q_FORMULAS.SUCCESS]: (data) => ({
    ...state,
    preQFormulas: { data: data.data, loading: false }
  }),
  [GET_SL_WORKFLOW.REQUEST]: () => ({
    ...state,
    workflow: { data: [], loading: true }
  }),
  [GET_SL_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    workflow: { data: data.data, loading: false }
  }),
  [CLEAR_SL_FROM_DATA]: () => ({
    ...state,
    shortList: { data: {}, loading: false }
  })
}))